
<template>
  <!--房间管理-->
  <div>
    <x-tabula
      ref="table"
      :rowOptLen="4"
      @resetSearch="resetSearch"
      :searchList="searchList"
      rowKey="roomId"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="true"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
    </x-tabula>
  </div>
</template>

<script>
import { empty } from 'ant-design-vue-admin-x';
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'room',
  data () {
    return {
      cascadeParam: {
        communityId: '',
        buildingId: ''
      },
      searchList: [
        { props: [`${this.$route.name}/communityId`], placeholder: '小区', options: [], inputType: 'select', handle: ($event) => this.communityChange(6, $event), fetchOptions: this.getOptions},
        { props: ['keywords'], placeholder: '房间号、业主姓名、业主手机号', options: [], inputType: 'input' },
        { props: ['type'], placeholder: '住宅类型', options: [], inputType: 'select' },
        { props: ['createDate'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' },
        {
          props: ['areas'],
          placeholder: '省市',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(4, 'searchList', '1,2,3', e);
          }
        },
        { props: ['propertyId'], placeholder: '物业公司', options: [], inputType: 'select' },
        { props: [`${this.$route.name}/buildingId`], placeholder: '楼栋', options: [], inputType: 'select', handle: ($event) => this.buildingChange(7, $event) },
        { props: [`${this.$route.name}/unitId`], placeholder: '单元', options: [], inputType: 'select' }
      ],
      searchParams: {
        [`${this.$route.name}/communityId`]: undefined,
        keywords: undefined,
        createDate: undefined,
        areas: undefined,
        propertyId: undefined,
        [`${this.$route.name}/buildingId`]: undefined,
        [`${this.$route.name}/unitId`]: undefined,
        type: undefined
      },
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['community:room:add'] },
        { text: '删除', icon: 'close', disabled: true, permi: ['community:room:remove'] },
        { text: '导入', icon: 'cloud-upload', handle: this.importRoom, permi: ['community:room:import'] }
      ],
      rowOptList: [
        { text: '住户信息', handle: (record) => this.roomInfo(record), permi: ['community:householder:query'] },
        { text: '修改', handle: (record) => this.$refs.table.toEdit(record), permi: ['community:room:edit'] },
        { text: '删除', handle: (record) => this.$refs.table.showDeleteConfirm(record), permi: ['community:room:remove'] }
      ],
      columns: [
        { title: '所在城市', dataIndex: 'area', align: 'left', width: '' },
        { title: '房间', dataIndex: 'room', align: 'left', width: '' },
        { title: '住宅类型', dataIndex: 'roomTypeDesc', align: 'left', width: '' },
        { title: '业主姓名', dataIndex: 'householdName', align: 'left', width: '' },
        { title: '手机号', dataIndex: 'mobilePhone', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      listApi: {
        url: '/room/list',
        resHandle: this.resHandle,
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addRoom',
        addTitle: '新增房间',
        editTitle: '修改房间'
      },
      deleteParam: {
        url: '/room/',
        title: '房间',
        key: 'room'
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'searchList', '0');
    },
    /* 获取下拉 */
    getSelect () {
      // this.communitySelect(0, 'searchList', 1);
      this.communitySelectByStep(1, undefined, 'searchList', '0');
      this.regionSelect(4);
      this.propertySelect(5);
      this.dictionarySelect([{index: 2, scope: 'searchList', query: 'comu_room_type'}]);
    },
    /** 重置搜索 */
    resetSearch () {
      empty.$emit('resetForm', ['buildingId', 'unitId']);
      this.searchList[6].options = [];
      this.searchList[7].options = [];
      this.communitySelectByStep(undefined, undefined, 'searchList', '0');
      this.searchList[0].searchValue = undefined;
    },
    /** 进入门卡信息页面 */
    toCardInfo (record) {
      this.$router.push({
        name: 'cardInfo',
        query: { id: record.roomId }
      });
    },
    /* 住房信息 */
    roomInfo (row) {
      this.$router.push({
        name: 'roomInfo',
        query: {
          id: row.roomId,
          roomName: row.room,
          ...this.breadParam(this)
        }
      });
    },
    /* 导入房间 */
    importRoom () {
      this.$router.push({
        name: 'importRoom',
        query: this.breadParam(this)
      });
    },
    resHandle (res) {
      res.forEach((ele) => {
        ele.room = `${ele.communityName} ${ele.buildingName} ${ele.unitName} ${ele.roomNo}`;
      });
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
